export const DATA_TEST_ID_PREFIX = 'design-posts--preview-actions';
